import { Dispatch, SetStateAction, useCallback, useState } from "react"
import { FaroInsightsWrapper } from "@/grafana-faro"
import { UpdateDePatientWizardV2 } from "@/modules/inbound-wizard/de-v2"
import useCallContextStore from "@/stores/useCallContextStore"

export const useOpenDePatientInboundCallV2 = (setPatientQuery?: Dispatch<SetStateAction<string>>) => {
  const country = useCallContextStore((state) => state.country)
  const callLineCode = useCallContextStore((state) => state.callLineCode)
  const record = useCallContextStore((state) => state.record)
  const callId = useCallContextStore((state) => state.callID)

  const [selectedPatientId, setSelectedPatientId] = useState("")
  const [selectedPatientName, setSelectedPatientName] = useState("")

  const openDePatientInboundCallV2 = useCallback(
    (patientId: string, patientName: string) => {
      FaroInsightsWrapper.pushEvent("ibc_initialize_ibc", {
        record: record ?? "",
        callLineCode: callLineCode,
        country: country,
        callID: callId ?? "",
      })
      setSelectedPatientId(patientId)
      setSelectedPatientName(patientName)
    },
    [callId, callLineCode, country, record],
  )

  const dePatientInboundCallDialogV2 = (
    <UpdateDePatientWizardV2
      patientId={selectedPatientId}
      patientName={selectedPatientName}
      open={Boolean(selectedPatientId)}
      onOpenChange={(isOpen) => {
        if (!isOpen) setSelectedPatientId("")
      }}
      setPatientQuery={setPatientQuery}
    />
  )

  return { openDePatientInboundCallV2, dePatientInboundCallDialogV2 }
}
